import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/mallApp/app_bg.png'


const _hoisted_1 = { id: "page_content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "download_des",
  "data-aos": "fade-down",
  "data-aos-duration": "800"
}, " 您可以通过手机自带的应用商城下载“归农”App商城。华为、苹果、小米、OPPO、VIVO等手机均可下载。 ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  id: "img",
  "data-aos": "zoom-in",
  "data-aos-duration": "1000",
  "data-aos-delay": "200"
}, null, -1)
const _hoisted_4 = {
  id: "btns",
  "data-aos": "fade-up",
  "data-aos-duration": "800",
  "data-aos-delay": "400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_btn = _resolveComponent("custom-btn")!
  const _component_PageFooter = _resolveComponent("PageFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.btns, (item, index) => {
          return (_openBlock(), _createBlock(_component_custom_btn, {
            key: index,
            config: item,
            onClick: ($event: any) => (_ctx.onDownload(index))
          }, null, 8, ["config", "onClick"]))
        }), 128))
      ])
    ]),
    _createVNode(_component_PageFooter)
  ], 64))
}